import { useMutation } from '@tanstack/react-query';
import { ALERT_STATUS, useAlert } from '../../../contexts/AlertContext';

import { editBrandBook } from '../../brandbooks';

const useEditBrandBook = (handleSuccess) => {
	const { handleAlert } = useAlert();

	const { mutate: handleEditBrandBook, isPending } = useMutation({
		mutationFn: (data) => editBrandBook(data),
		onSuccess: handleSuccess,
		onError: (error) => {
			handleAlert(ALERT_STATUS.ERROR, error.response.data.error);
		},
	});

	return { handleEditBrandBook, isPending };
};

export default useEditBrandBook;
